var map = {
	"./IMG-20250403-WA0000.jpg": 2359,
	"./IMG-20250403-WA0002.jpg": 6421,
	"./IMG-20250406-WA0004.jpg": 6880,
	"./IMG-20250406-WA0005.jpg": 6109,
	"./IMG-20250411-WA0000.jpg": 6296,
	"./IMG-20250411-WA0001.jpg": 613,
	"./IMG-20250411-WA0002.jpg": 8538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8591;